import { OfferState, PersonState, PersonSupplementaryInsuranceState } from './offer.state';

function splitPersonsByPersonId(personId: number, persons: PersonState[]): [PersonState, PersonState[]] {
  const personState = persons.find((person) => person.personId === personId);
  if (!personState) {
    throw new Error(`Could not find person with ID ${personId}.`);
  }
  const otherPersons = persons.filter((person) => person.personId !== personId);
  return [personState, otherPersons];
}

export function applyToPersonWithId(
  personId: number,
  persons: PersonState[],
  personReducer: (person: PersonState) => PersonState,
): PersonState[] {
  const [affectedPerson, otherPersons] = splitPersonsByPersonId(personId, persons);
  return [...otherPersons, personReducer(affectedPerson)].sort(
    (person1, person2) => person1.personId - person2.personId,
  );
}

export function removeOfferPricesOnPersons(offerState: OfferState): PersonState[] {
  return offerState.persons.map((person) => ({
    ...person,
    basicInsurance: person.basicInsurance && {
      ...person.basicInsurance,
      price: undefined,
    },
    supplementaryInsurances: removeSupplementaryInsurancePrices(person.supplementaryInsurances),
    discounts: {
      basicInsuranceDiscounts: [],
      supplementaryInsuranceDiscounts: {},
    },
    totalPrice: undefined,
  }));
}

export function removeSupplementaryInsurancePrices(
  supplementaryInsurances: PersonSupplementaryInsuranceState,
): PersonSupplementaryInsuranceState {
  const supplementaryWithoutPrice: PersonSupplementaryInsuranceState = {};

  Object.entries(supplementaryInsurances).forEach(([key, value]) => {
    if (value) {
      const insuranceKey = key as keyof PersonSupplementaryInsuranceState;
      supplementaryWithoutPrice[insuranceKey] = {
        ...value,
        price: undefined,
      };
    }
  });
  return supplementaryWithoutPrice;
}
